class apiJSON {
    get(url) {
        // load activity json file
        const request = new XMLHttpRequest();
        request.open('GET', `${url}`, false);
        request.send(null);
        return JSON.parse(request.responseText);
    }
}

export default new apiJSON();
